// src/api/client.js
export const apiClient = async (url, options = {}) => {
  const response = await fetch(url, {
    credentials: "include",
    headers: { Accept: "application/json" },
    ...options
  });

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  return response.json();
};